import { useMutation } from 'react-query';

import { setReport } from 'api/endPoints/setReport';

import { BreakPointMap } from 'components/Dashboards/Reporting/reporting.types';

export const useMutationSetReport = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => setReport(params),
    });
};

export interface APIFnResponse {
    status: number;
}

interface QueryParams {
    name: string;
    gridLayout?: BreakPointMap;
}

interface QueryResponse {
    id: number;
}
